import * as React from 'react';
import { useSelector } from 'react-redux';

import { selectBrokerConsultantBannerAvailable } from '../../selectors/brokerConsultantBanner';
import { isDiscountMortgageBannerEnabled } from '../../selectors/discountMortgage';
import { useApplicationContext } from '../../utils/applicationContext';
import { DiscountMortgageBannerContainer } from '../DiscountMortgageBannerContainer';
import { BrokerConsultantBannerContainer } from '../BrokerConsultantBannerContainer';
import { NewbuildingPrizeBannerContainer } from '../NewbuildingPrizeBannerContainer';

export const BannerContainer = () => {
  const { config } = useApplicationContext();
  const isDiscountMortgageBannerAvailable = useSelector(isDiscountMortgageBannerEnabled);
  const isBrokerConsultantBannerAvailable = useSelector(selectBrokerConsultantBannerAvailable);
  const isPrizeBannerEnabled = config.get<boolean>('Newbuilding.PrizeBanner.Enabled') || false;

  if (isPrizeBannerEnabled) {
    return <NewbuildingPrizeBannerContainer />;
  }

  if (isDiscountMortgageBannerAvailable) {
    return <DiscountMortgageBannerContainer />;
  }

  if (isBrokerConsultantBannerAvailable) {
    return <BrokerConsultantBannerContainer />;
  }

  return null;
};
